export { ReactComponent as BulletList } from './svgs/bullet-list.svg';
